import { Toast } from "vant";
  // 打包前看readme文件
export const mixins = {
  data() {
    return {
      urlList: [
        { time: 0, name: '欲漫涩', url: 'https://d2ob99u7vvfz31.cloudfront.net', webUrl: 'https://d1s8wm47asyysy.cloudfront.net' },
        { time: 0, name: '萝莉岛', url: 'https://d16ftfdbdupx5w.cloudfront.net', webUrl: 'https://d1q6v0m0fmxvl0.cloudfront.net' },
        { time: 0, name: '麻豆', url: 'https://d2m28mpb1bymxk.cloudfront.net', webUrl: 'https://d2m1d86x8ze4id.cloudfront.net' },
        { time: 0, name: '海角乱伦', url: 'https://d2kvdl19x6g5nx.cloudfront.net', webUrl: 'https://doyj68zud8dgm.cloudfront.net' },
        { time: 0, name: 'pornhub中文版', url: 'https://d3o2pe7tltv1ly.cloudfront.net', webUrl: 'https://d2o7c2qy2lvgf1.cloudfront.net' },
        { time: 0, name: 'xvideos', url: 'https://dtualtp1hoqca.cloudfront.net', webUrl: 'https://d4yzu2s8mrrvk.cloudfront.net' },

        { time: 0, name: '91porn', url: 'https://d39dinfr9fa757.cloudfront.net'},
        { time: 0, name: '萝莉岛', url: 'https://d5z8k7dgp195r.cloudfront.net', webUrl: 'ttps://d2xw96fnbwxopk.cloudfront.net'},
        { time: 0, name: 'pornhub精品版', url: 'https://d3bd5bgz4c3sw1.cloudfront.net' },
        { time: 0, name: '妖精漫画', url: 'https://dtjvcwr4vmqah.cloudfront.net/' },
        { time: 0, name: '糖心视频', url: 'https://d3v84u35xztxp3.cloudfront.net' },
        { time: 0, name: '91暗网', url: 'https://d2ghwef9r9yvcj.cloudfront.net', webUrl: 'https://dh0n7f6bcnjxj.cloudfront.net' },
        { time: 0, name: '好色', url: 'https://d2t0fvueqmswge.cloudfront.net', webUrl: 'https://d39cmeitkp3imu.cloudfront.net' },
        { time: 0, name: 'Soul', url: 'https://d44jahimpif96.cloudfront.net', webUrl: 'https://d1u1x3yp88ozd.cloudfront.net' },
        { time: 0, name: '逼哩逼哩', url: 'https://d1gptnfinh2tzk.cloudfront.net' },
        { time: 0, name: '哆哔涩漫', url: 'https://di6yxrkzg7nwu.cloudfront.net'},

        { time: 0, name: 'XVideos破解版', url: 'https://d3rulkta3in0ac.cloudfront.net' },
        { time: 0, name: '波多', url: 'https://d3svt3ir67x2bk.cloudfront.net' },
        { time: 0, name: '妻友', url: 'https://d1am0p956cgkhz.cloudfront.net' },

        { time: 0, name: '快手', url: 'https://d14m3mq9qqdlx3.cloudfront.net' },
        { time: 0, name: 'XV暗网', url: 'https://d31aen8w50n8qh.cloudfront.net/' },
         { time: 0, name: '黑料社', url: 'https://d3924gkh7q4qg1.cloudfront.net/' },
        { time: 0, name: '腾讯涩漫', url: 'https://djtghfo9vj5ev.cloudfront.net/' },
        { time: 0, name: '泡芙视频', url: 'https://d3mq6tk9sqh421.cloudfront.net/' },
      ],
      ping: 1,
      timer: null,
      showImg: true,
      addressUrl: "cao.gg",
    };
  },
  mounted() {
    this.addressUrl = window.location.host;
    this.$nextTick(() => {
      this.init();
    });
  },
  methods: {
    init() {
      this.timer = setInterval(() => {
        this.ping++;
      }, 100);
    },
    autoTest(item, index) {
      if (this.ping <= 10) {
        item.time = this.ping * 10;
      } else {
        item.time = this.ping * 100;
      }
      if (index == this.urlList.length - 1) {
        clearInterval(this.timer);
      }
    },
    jumpUrl(url) {
      const routeDc = this.$route.query.dc
      if (routeDc) {
        window.open(url + '?dc=' + routeDc);
      } else {
        const dc = process.env.VUE_APP_WEB_DC || 985
        window.open(url + '?dc=' + dc);
      }
    },
    reset() {
      this.urlList = this.urlList.map((item) => {
        item.time = 0;
        return item;
      });
      this.showImg = false;
      this.$nextTick(() => {
        this.showImg = true;
      });
      this.ping = 1;
      this.init();
    },
    doCopy() {
      let req = this.addressUrl;
      this.$copyText(req).then(
        () => {
          Toast("复制成功");
        },
        () => {
          Toast("复制失败");
        }
      );
    },
  },
};
